
export default {
  name: "rows-table",
  components: {

  },
    props: {
      rows: {
        type: Array,
        default: () => {
          [];
        },
      },
      getUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      deleteUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      salvarUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      veiculos: {
        type: Array,
        default: () => {
          [];
        },
      },
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
      }
    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const getUnico = (row: any) => {
          props.getUnico(row); // Define o novo cen tro do mapa
      };

      const salvarUnico = (data:any) => {
          props.salvarUnico(data); // Define o novo cen tro do mapa
      };


      const setStatus = (data:any) => {

          let data_update = {ativo: data.ativo, id:data.id }
          props.salvarUnico(data_update); // Define o novo cen tro do mapa
      };

      const deleteUnico = (row: any) => {
          props.deleteUnico(row); // Define o novo cen tro do mapa
      };
      // Retorna os métodos ou variáveis que você quer expor
      return {
        getUnico,
        deleteUnico,
        setStatus,
        salvarUnico
      };

    }

};
